import { Directive, ElementRef, forwardRef, Renderer2 } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';


export const TIME_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => TimeValueAccessor),
    multi: true,
};


@Directive({
    selector: 'input[type="time"][formControlName], input[type="time"][formControl], input[type="time"][ngModel]',
    host: {
        '(change)': 'sanitizeValue($event.target.valueAsNumber)',
        '(blur)': 'onTouched()'
    },
    providers: [TIME_VALUE_ACCESSOR]
})
export class TimeValueAccessor implements ControlValueAccessor {

    onChange: (value: number) => void;
    onTouched: () => void;

    constructor(
        private readonly renderer: Renderer2,
        private readonly elementRef: ElementRef,
    ) {}

    registerOnChange(fn: any): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }

    setDisabledState(isDisabled: boolean): void {
        this.renderer.setProperty(this.elementRef.nativeElement, 'disabled', isDisabled);
    }

    writeValue(value: any): void {
        this.renderer.setProperty(
            this.elementRef.nativeElement,
            typeof value === 'number' ? 'valueAsNumber' : 'value',
            value
        );
    }

    sanitizeValue(value?: number) {
        this.onChange(isNaN(value) ? undefined : value)
    }
}
